// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex {\n    display: flex;\n}\n.container {\n    width: 100%;\n    height: 100%;\n}\n.flexColumn {\n    display: flex;\n    flex-direction: column;\n}\n.flexCenterChildren {\n    align-items: center;\n    justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
